<template>
  <div class="content d-flex flex-column flex-column-fluid mb-10" id="kt_content">
    <div class="toolbar" id="kt_toolbar">
      <div id="kt_toolbar_container" class="container-fluid d-flex flex-stack">
        <div data-kt-swapper="true" data-kt-swapper-mode="prepend"
          data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
          class="page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0">
          <h1 class="d-flex text-dark fw-bolder fs-3 align-items-center my-1">{{ $t(title) }}</h1>
          <span class="h-20px border-gray-300 border-start mx-4"></span>
          <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
            <div v-for="(bread, key) in breadcrumbs" :key="key">
              <div>
                <li class="breadcrumb-item text-muted" v-if="key + 1 !== breadcrumbs.length">
                  <router-link :to="bread.path" class="text-muted text-hover-primary">{{ $t(bread.name) }}</router-link>
                </li>
                <li class="breadcrumb-item" v-if="key + 1 !== breadcrumbs.length">
                  <span class="bullet bg-gray-300 w-5px h-2px"></span>
                </li>
              </div>
            </div>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <div class="m-0">
            <select name="filter" style="width:250px!important;" v-model="shop_selected" data-control="select2"
              data-search="true" data-placeholder="Filter"
              class="form-select kt_select form-select-sm border-primary  w-200px me-5">
              <option :value="'all'" selected> {{ $t('dashboard.all_shop') }}</option>
              <option v-if="$hasModule('ecommerce')" :value="'ecommerce'" > {{ $t('dashboard.ecommerce') }}</option>
              <option v-for="filter in shops" :value="filter.id" :key="filter.id">{{ filter.name }}</option>
            </select>
          </div>
          <div class="card-toolbar">
            <div dashboard-kt-daterangepicker="true" data-kt-daterangepicker-opens="left"
              class="btn btn-sm btn-light d-flex align-items-center px-4">
              <div class="text-gray-600 fw-bolder">{{ $t('dashboard.loading') }}...</div>
              <span class="svg-icon svg-icon-1 ms-2 me-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path opacity="0.3"
                    d="M21 22H3C2.4 22 2 21.6 2 21V5C2 4.4 2.4 4 3 4H21C21.6 4 22 4.4 22 5V21C22 21.6 21.6 22 21 22Z"
                    fill="currentColor" />
                  <path
                    d="M6 6C5.4 6 5 5.6 5 5V3C5 2.4 5.4 2 6 2C6.6 2 7 2.4 7 3V5C7 5.6 6.6 6 6 6ZM11 5V3C11 2.4 10.6 2 10 2C9.4 2 9 2.4 9 3V5C9 5.6 9.4 6 10 6C10.6 6 11 5.6 11 5ZM15 5V3C15 2.4 14.6 2 14 2C13.4 2 13 2.4 13 3V5C13 5.6 13.4 6 14 6C14.6 6 15 5.6 15 5ZM19 5V3C19 2.4 18.6 2 18 2C17.4 2 17 2.4 17 3V5C17 5.6 17.4 6 18 6C18.6 6 19 5.6 19 5Z"
                    fill="currentColor" />
                  <path
                    d="M8.8 13.1C9.2 13.1 9.5 13 9.7 12.8C9.9 12.6 10.1 12.3 10.1 11.9C10.1 11.6 10 11.3 9.8 11.1C9.6 10.9 9.3 10.8 9 10.8C8.8 10.8 8.59999 10.8 8.39999 10.9C8.19999 11 8.1 11.1 8 11.2C7.9 11.3 7.8 11.4 7.7 11.6C7.6 11.8 7.5 11.9 7.5 12.1C7.5 12.2 7.4 12.2 7.3 12.3C7.2 12.4 7.09999 12.4 6.89999 12.4C6.69999 12.4 6.6 12.3 6.5 12.2C6.4 12.1 6.3 11.9 6.3 11.7C6.3 11.5 6.4 11.3 6.5 11.1C6.6 10.9 6.8 10.7 7 10.5C7.2 10.3 7.49999 10.1 7.89999 10C8.29999 9.90003 8.60001 9.80003 9.10001 9.80003C9.50001 9.80003 9.80001 9.90003 10.1 10C10.4 10.1 10.7 10.3 10.9 10.4C11.1 10.5 11.3 10.8 11.4 11.1C11.5 11.4 11.6 11.6 11.6 11.9C11.6 12.3 11.5 12.6 11.3 12.9C11.1 13.2 10.9 13.5 10.6 13.7C10.9 13.9 11.2 14.1 11.4 14.3C11.6 14.5 11.8 14.7 11.9 15C12 15.3 12.1 15.5 12.1 15.8C12.1 16.2 12 16.5 11.9 16.8C11.8 17.1 11.5 17.4 11.3 17.7C11.1 18 10.7 18.2 10.3 18.3C9.9 18.4 9.5 18.5 9 18.5C8.5 18.5 8.1 18.4 7.7 18.2C7.3 18 7 17.8 6.8 17.6C6.6 17.4 6.4 17.1 6.3 16.8C6.2 16.5 6.10001 16.3 6.10001 16.1C6.10001 15.9 6.2 15.7 6.3 15.6C6.4 15.5 6.6 15.4 6.8 15.4C6.9 15.4 7.00001 15.4 7.10001 15.5C7.20001 15.6 7.3 15.6 7.3 15.7C7.5 16.2 7.7 16.6 8 16.9C8.3 17.2 8.6 17.3 9 17.3C9.2 17.3 9.5 17.2 9.7 17.1C9.9 17 10.1 16.8 10.3 16.6C10.5 16.4 10.5 16.1 10.5 15.8C10.5 15.3 10.4 15 10.1 14.7C9.80001 14.4 9.50001 14.3 9.10001 14.3C9.00001 14.3 8.9 14.3 8.7 14.3C8.5 14.3 8.39999 14.3 8.39999 14.3C8.19999 14.3 7.99999 14.2 7.89999 14.1C7.79999 14 7.7 13.8 7.7 13.7C7.7 13.5 7.79999 13.4 7.89999 13.2C7.99999 13 8.2 13 8.5 13H8.8V13.1ZM15.3 17.5V12.2C14.3 13 13.6 13.3 13.3 13.3C13.1 13.3 13 13.2 12.9 13.1C12.8 13 12.7 12.8 12.7 12.6C12.7 12.4 12.8 12.3 12.9 12.2C13 12.1 13.2 12 13.6 11.8C14.1 11.6 14.5 11.3 14.7 11.1C14.9 10.9 15.2 10.6 15.5 10.3C15.8 10 15.9 9.80003 15.9 9.70003C15.9 9.60003 16.1 9.60004 16.3 9.60004C16.5 9.60004 16.7 9.70003 16.8 9.80003C16.9 9.90003 17 10.2 17 10.5V17.2C17 18 16.7 18.4 16.2 18.4C16 18.4 15.8 18.3 15.6 18.2C15.4 18.1 15.3 17.8 15.3 17.5Z"
                    fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="post d-flex flex-column-fluid" id="kt_post">
      <div v-show="isReady" id="kt_content_container" class="container-xxl">

        <!-- ─── KPI Cards ─────────────────────────────────────────────── -->
        <div class="d-flex gap-5 flex-wrap mb-7">

          <!-- E-commerce -->
          <div v-if="$hasModule('ecommerce') && (shop_selected === 'all' || shop_selected === 'ecommerce')"
               class="card kpi-card kpi-ecommerce flex-fill">
            <div class="card-body px-7 py-6 d-flex flex-column">
              <div class="d-flex align-items-center mb-5">
                <div class="kpi-icon-box bg-light-success me-4">
                  <i class="bi bi-cart3 text-success fs-1"></i>
                </div>
                <div class="flex-grow-1">
                  <div class="fw-bolder fs-5 text-dark">{{ $t('dashboard.ecommerce') }}</div>
                  <div class="text-muted fs-7">{{ $t('dashboard_kpi.online_store') }}</div>
                </div>
                <!-- Compteurs en haut de carte (les annulations ne concernent que les commandes en ligne) -->
                <div class="kpi-counters">
                  <div class="kpi-counter">
                    <span class="kpi-counter-value text-success">{{ stats?.ecommerce?.paid_orders ?? 0 }}</span>
                    <span class="kpi-counter-label">{{ $t('dashboard_kpi.paid') }}</span>
                  </div>
                  <div class="kpi-counter">
                    <span class="kpi-counter-value text-warning">{{ stats?.ecommerce?.pending_orders ?? 0 }}</span>
                    <span class="kpi-counter-label">{{ $t('dashboard_kpi.pending') }}</span>
                  </div>
                  <div class="kpi-counter">
                    <span class="kpi-counter-value text-danger">{{ stats?.ecommerce?.cancelled_orders ?? 0 }}</span>
                    <span class="kpi-counter-label">{{ $t('dashboard_kpi.cancelled') }}</span>
                  </div>
                  <div class="kpi-counter">
                    <span class="kpi-counter-value text-dark">{{ stats?.ecommerce?.total_orders ?? 0 }}</span>
                    <span class="kpi-counter-label">{{ $t('dashboard_kpi.total') }}</span>
                  </div>
                </div>
              </div>
              <div class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-center">
                <div class="fs-2x fw-bolder text-dark lh-1">
                  {{ $formatLocalAmount(stats?.ecommerce?.total_paid_orders ?? 0) }}
                  <small class="fs-4 fw-semibold text-muted ms-1">{{ currency }}</small>
                </div>
                <div class="text-muted fs-7 mt-1">{{ $t('dashboard.paid_orders') }}</div>
                <div class="mt-2 d-inline-flex align-items-center gap-1 px-3 py-1 rounded bg-light-success">
                  <i class="bi bi-basket2 text-success fs-8"></i>
                  <span class="text-success fw-bold fs-8">{{ $t('dashboard_kpi.avg_basket') }} {{ avgBasketEcommerce }} {{ currency }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- POS -->
          <div v-if="shop_selected === 'all' || isUUID(shop_selected)"
               class="card kpi-card kpi-pos flex-fill">
            <div class="card-body px-7 py-6 d-flex flex-column">
              <div class="d-flex align-items-center mb-5">
                <div class="kpi-icon-box bg-light-primary me-4">
                  <i class="bi bi-shop text-primary fs-1"></i>
                </div>
                <div class="flex-grow-1">
                  <div class="fw-bolder fs-5 text-dark">{{ $t('dashboard.pos') }}</div>
                  <div class="text-muted fs-7">{{ $t('dashboard_kpi.point_of_sale') }}</div>
                </div>
                <div class="kpi-counters">
                  <div class="kpi-counter">
                    <span class="kpi-counter-value text-primary">{{ stats?.pos?.total_sales_count ?? 0 }}</span>
                    <span class="kpi-counter-label">{{ $t('dashboard_kpi.sales') }}</span>
                  </div>
                  <div class="kpi-counter">
                    <span class="kpi-counter-value text-info">{{ stats?.pos?.total_products ?? 0 }}</span>
                    <span class="kpi-counter-label">{{ $t('dashboard_kpi.products') }}</span>
                  </div>
                  <div class="kpi-counter">
                    <span class="kpi-counter-value text-dark">{{ stats?.pos?.unique_customers ?? 0 }}</span>
                    <span class="kpi-counter-label">{{ $t('dashboard_kpi.clients') }}</span>
                  </div>
                </div>
              </div>
              <div class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-center">
                <div class="fs-2x fw-bolder text-dark lh-1">
                  {{ $formatLocalAmount(stats?.pos?.total_paid_orders ?? 0) }}
                  <small class="fs-4 fw-semibold text-muted ms-1">{{ currency }}</small>
                </div>
                <div class="text-muted fs-7 mt-1">{{ $t('dashboard.total_sales') }}</div>
                <div class="mt-2 d-inline-flex align-items-center gap-1 px-3 py-1 rounded bg-light-primary">
                  <i class="bi bi-basket2 text-primary fs-8"></i>
                  <span class="text-primary fw-bold fs-8">{{ $t('dashboard_kpi.avg_basket') }} {{ avgBasketPos }} {{ currency }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- CA Global -->
          <div class="card kpi-card kpi-combined flex-fill">
            <div class="card-body px-7 py-6 d-flex flex-column">
              <div class="d-flex align-items-center mb-5">
                <div class="kpi-icon-box bg-light-warning me-4">
                  <i class="bi bi-graph-up-arrow text-warning fs-1"></i>
                </div>
                <div>
                  <div class="fw-bolder fs-5 text-dark">{{ $t('dashboard.turnover') }}</div>
                  <div class="text-muted fs-7">{{ $t('dashboard_kpi.all_sources') }}</div>
                </div>
              </div>
              <div class="flex-grow-1 d-flex flex-column align-items-center justify-content-center text-center">
                <div class="kpi-big-number">
                  {{ $formatLocalAmount(stats?.combined?.total_paid_orders ?? 0) }}
                  <small class="fs-4 fw-semibold text-muted ms-1">{{ currency }}</small>
                </div>
                <div class="mt-2 d-inline-flex align-items-center gap-1 px-3 py-1 rounded bg-light-warning">
                  <i class="bi bi-basket2 text-warning fs-8"></i>
                  <span class="text-warning fw-bold fs-8">{{ $t('dashboard_kpi.avg_basket') }} {{ avgBasketCombined }} {{ currency }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ─── Alertes Stock (POS uniquement) ──────────────────────── -->
        <div v-if="stockAlerts && stockAlerts.total > 0 && shop_selected !== 'ecommerce'" class="mb-5">
          <div class="card border-0 bg-light-secondary">
            <div class="card-body py-4 px-6">
              <div class="d-flex align-items-center justify-content-between flex-wrap gap-3">
                <div class="d-flex align-items-center gap-2">
                  <i class="bi bi-box-seam text-muted fs-4"></i>
                  <span class="fw-semibold text-muted fs-7">{{ $t('dashboard_kpi.stock_alerts') }}</span>
                  <span class="badge badge-light-secondary text-muted ms-1">{{ stockAlerts.total }}</span>
                </div>
                <div class="d-flex gap-4 flex-wrap">
                  <component
                    :is="stockAlerts.shop_id ? 'router-link' : 'span'"
                    :to="stockAlerts.shop_id ? { name: 'shop-products-ended', params: { id: stockAlerts.shop_id }, query: { filter: 'rupture' } } : undefined"
                    class="stock-alert-pill pill-rupture"
                    :class="{ 'pill-link': !!stockAlerts.shop_id }"
                  >
                    <span class="pill-dot"></span> {{ $t('dashboard_kpi.out_of_stock') }} <strong>{{ stockAlerts.rupture }}</strong>
                  </component>
                  <component
                    :is="stockAlerts.shop_id ? 'router-link' : 'span'"
                    :to="stockAlerts.shop_id ? { name: 'shop-products-ended', params: { id: stockAlerts.shop_id }, query: { filter: 'critique' } } : undefined"
                    class="stock-alert-pill pill-critique"
                    :class="{ 'pill-link': !!stockAlerts.shop_id }"
                  >
                    <span class="pill-dot"></span> {{ $t('dashboard_kpi.critical') }} <strong>{{ stockAlerts.critique }}</strong>
                  </component>
                  <component
                    :is="stockAlerts.shop_id ? 'router-link' : 'span'"
                    :to="stockAlerts.shop_id ? { name: 'shop-products-ended', params: { id: stockAlerts.shop_id }, query: { filter: 'alerte' } } : undefined"
                    class="stock-alert-pill pill-alerte"
                    :class="{ 'pill-link': !!stockAlerts.shop_id }"
                  >
                    <span class="pill-dot"></span> {{ $t('dashboard_kpi.low_stock') }} <strong>{{ stockAlerts.alerte }}</strong>
                  </component>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ─── Évolution des ventes (combo jour / semaine) ─────────── -->
        <div class="row mb-5">
          <div class="col-12">
            <div class="card dashboard-card chart-evolution-card">
              <div class="card-header border-0 pt-6 pb-2">
                <div class="card-title d-flex align-items-center gap-3">
                  <div class="section-icon bg-light-primary">
                    <i class="bi bi-bar-chart-line text-primary fs-2"></i>
                  </div>
                  <div>
                    <h3 class="fw-bolder mb-0">{{ $t('dashboard_kpi.sales_evolution') }}</h3>
                    <span class="text-muted fs-7">{{ $t('dashboard.sales') }}</span>
                  </div>
                </div>
                <div class="card-toolbar">
                  <div class="btn-group">
                    <button class="btn btn-sm"
                      :class="salesView === 'daily' ? 'btn-primary' : 'btn-light'"
                      @click="setSalesView('daily')">
                      <i class="bi bi-calendar-day me-1"></i>{{ $t('dashboard_kpi.by_day') }}
                    </button>
                    <button class="btn btn-sm"
                      :class="salesView === 'weekly' ? 'btn-primary' : 'btn-light'"
                      @click="setSalesView('weekly')">
                      <i class="bi bi-calendar-week me-1"></i>{{ $t('dashboard_kpi.by_week') }}
                    </button>
                  </div>
                </div>
              </div>

              <!-- Mini KPI strip -->
              <div class="d-flex gap-7 px-7 py-4 border-bottom">
                <div>
                  <div class="text-muted fs-8 fw-bold text-uppercase ls-1">{{ $t('dashboard_kpi.period_turnover') }}</div>
                  <div class="fw-bolder fs-4 text-dark mt-1">{{ periodCaTotal }} {{ currency }}</div>
                </div>
                <div class="border-start ps-7">
                  <div class="text-muted fs-8 fw-bold text-uppercase ls-1">{{ $t('dashboard_kpi.orders') }}</div>
                  <div class="fw-bolder fs-4 text-dark mt-1">{{ periodOrdersTotal }}</div>
                </div>
                <div class="border-start ps-7">
                  <div class="text-muted fs-8 fw-bold text-uppercase ls-1">{{ $t('dashboard_kpi.avg_per_day') }}</div>
                  <div class="fw-bolder fs-4 text-dark mt-1">{{ periodAvgDay }} {{ currency }}</div>
                </div>
              </div>

              <div class="card-body pt-4">
                <div class="text-center py-10" v-if="(salesView === 'daily' && salesEmpty) || (salesView === 'weekly' && weeklyEmpty)">
                  <img src="@/assets/media/pos/Empty1.png" alt="" class="h-150px" />
                  <div class="text-gray-400 fs-5 fw-bold mt-3">{{ $t('no_data_found') }}</div>
                </div>
                <template v-else>
                  <div v-show="salesView === 'daily'"  id="kt_charts_widget_3"  style="height:320px"></div>
                  <div v-show="salesView === 'weekly'" id="chart_weekly_apex"   style="height:320px"></div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- ─── Heures de pointe : jour × heure ───────────────────────── -->
        <div class="row mb-5">
          <div class="col-12">
            <div class="card dashboard-card">
              <div class="card-header border-0 pt-6 pb-2">
                <div class="card-title d-flex align-items-center gap-3">
                  <div class="section-icon bg-light-primary">
                    <i class="bi bi-clock-history text-primary fs-2"></i>
                  </div>
                  <div>
                    <h3 class="fw-bolder mb-0">{{ $t('dashboard_kpi.peak_hours') }}</h3>
                    <span class="text-muted fs-7">{{ heatSubtitle }}</span>
                  </div>
                </div>
                <div class="card-toolbar">
                  <!-- Caisse ou en ligne : ils ne s'additionnent pas, l'un sert au personnel, l'autre au marketing. -->
                  <div v-if="heatChannels.length > 1" class="btn-group">
                    <button v-for="channel in heatChannels" :key="channel" type="button" class="btn btn-sm"
                      :class="heatChannel === channel ? 'btn-primary' : 'btn-light'"
                      @click="heatChannel = channel">
                      <i :class="channel === 'pos' ? 'bi bi-shop' : 'bi bi-cart3'" class="me-1"></i>{{ $t(`dashboard_kpi.heat_channel_${channel}`) }}
                    </button>
                  </div>
                  <span v-else-if="heatChannels.length" class="badge badge-light fw-semibold">
                    <i :class="heatChannel === 'pos' ? 'bi bi-shop' : 'bi bi-cart3'" class="me-1"></i>{{ $t(`dashboard_kpi.heat_channel_${heatChannel}`) }}
                  </span>
                </div>
              </div>
              <div class="card-body pt-4">
                <div class="text-center py-10" v-if="!heatCells.size">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="h-150px" />
                  <div class="text-gray-400 fs-5 fw-bold mt-3">{{ $t('no_data_found') }}</div>
                </div>
                <div class="text-center py-10" v-else-if="heatTooFew">
                  <i class="bi bi-hourglass-split text-gray-400 fs-2x"></i>
                  <div class="text-gray-600 fs-6 fw-semibold mt-3">{{ $t('dashboard_kpi.heat_online_too_few', { n: heatTotal, min: MIN_ONLINE_ORDERS }, heatTotal) }}</div>
                </div>
                <template v-else>
                  <div class="heatmap-scroll">
                    <div class="heatmap" :style="{ '--hours': heatHours.length }">
                      <span></span>
                      <span v-for="hour in heatHours" :key="`h-${hour}`" class="heatmap-hour">{{ hour % 2 === 0 ? `${hour}h` : '' }}</span>
                      <template v-for="day in 7" :key="`d-${day}`">
                        <span class="heatmap-day">{{ $t(`statistics.weekdays.${day}`) }}</span>
                        <span
                          v-for="hour in heatHours"
                          :key="`${day}-${hour}`"
                          class="heatmap-cell"
                          :class="`level-${heatLevel(heatCount(day, hour))}`"
                          :title="heatCount(day, hour) ? $t('statistics.hour_cell', { day: $t(`statistics.weekdays.${day}`), from: hour, to: hour + 1, n: heatCount(day, hour) }, heatCount(day, hour)) : undefined"
                        ></span>
                      </template>
                    </div>
                  </div>
                  <div class="heatmap-legend">
                    <span>{{ $t('statistics.fewer') }}</span>
                    <span v-for="index in 5" :key="index" class="heatmap-cell" :class="`level-${index}`"></span>
                    <span>{{ $t('statistics.more') }}</span>
                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!-- ─── Top Produits : chart horizontal + classement ─────────── -->
        <div class="row mb-5">
          <div class="col-12">
            <div class="card dashboard-card">
              <div class="card-header border-0 pt-6 pb-4">
                <div class="card-title d-flex align-items-center gap-3">
                  <div class="section-icon bg-light-warning">
                    <i class="bi bi-trophy text-warning fs-2"></i>
                  </div>
                  <div>
                    <h3 class="fw-bolder mb-0">{{ $t('dashboard_kpi.top_products') }}</h3>
                    <span class="text-muted fs-7">{{ $t('dashboard_kpi.top_products_subtitle') }}</span>
                  </div>
                </div>
              </div>
              <div class="card-body pt-2">
                <div class="text-center py-10" v-if="productMostSalesAmountEmpty">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="h-150px" />
                  <div class="text-gray-400 fs-5 fw-bold mt-3">{{ $t('no_data_found') }}</div>
                </div>
                <!-- Mobile : 2 grilles 2 colonnes -->
                <div v-else-if="isMobile">
                  <!-- Par CA -->
                  <div class="text-muted fs-8 fw-bold text-uppercase ls-1 mb-3">
                    <i class="bi bi-currency-dollar me-1"></i>{{ $t('dashboard_kpi.by_turnover') }}
                  </div>
                  <div class="row g-3 mb-5">
                    <div v-for="(p, i) in productMostSalesAmount.slice(0, 8)" :key="'a'+i" class="col-6">
                      <div class="cat-stat-card">
                        <div class="cat-stat-name">{{ p.title }}</div>
                        <div class="cat-stat-value" style="color:#3699FF">
                          {{ $formatLocalAmount(p.total) }}
                          <small class="cat-stat-currency">{{ currency }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Par quantité -->
                  <div class="text-muted fs-8 fw-bold text-uppercase ls-1 mb-3">
                    <i class="bi bi-box-seam me-1"></i>{{ $t('dashboard_kpi.by_qty_sold') }}
                  </div>
                  <div class="row g-3">
                    <div v-for="(p, i) in productMostSalesNumber.slice(0, 8)" :key="'q'+i" class="col-6">
                      <div class="cat-stat-card">
                        <div class="cat-stat-name">{{ p.title }}</div>
                        <div class="cat-stat-value" style="color:#FFC700">
                          {{ p.total }}
                          <small class="cat-stat-currency">{{ $t('dashboard_kpi.unit_short') }}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Desktop : chart + classement -->
                <div v-else class="row g-5 align-items-start">
                  <!-- Chart CA -->
                  <div class="col-lg-8">
                    <div class="text-muted fs-8 fw-bold text-uppercase ls-1 mb-3">
                      <i class="bi bi-currency-dollar me-1"></i>{{ $t('dashboard_kpi.by_turnover') }}
                    </div>
                    <div id="chart_top_products_amount" style="height:320px"></div>
                  </div>
                  <!-- Classement par quantité -->
                  <div class="col-lg-4">
                    <div class="text-muted fs-8 fw-bold text-uppercase ls-1 mb-3">
                      <i class="bi bi-box-seam me-1"></i>{{ $t('dashboard_kpi.by_qty_sold') }}
                    </div>
                    <div class="top-rank-list">
                      <div v-for="(p, i) in productMostSalesNumber.slice(0, 8)" :key="'q'+i" class="rank-item">
                        <div class="rank-badge" :class="i === 0 ? 'rank-gold' : i === 1 ? 'rank-silver' : i === 2 ? 'rank-bronze' : 'rank-other'">
                          {{ i === 0 ? '🥇' : i === 1 ? '🥈' : i === 2 ? '🥉' : i + 1 }}
                        </div>
                        <div class="flex-grow-1 min-w-0">
                          <div class="fw-bold text-dark fs-7 text-truncate mb-1">{{ p.title }}</div>
                          <div class="progress" style="height:5px;border-radius:3px">
                            <div class="progress-bar bg-warning"
                              :style="{ width: Math.round(p.total / (productMostSalesNumber[0]?.total || 1) * 100) + '%' }">
                            </div>
                          </div>
                        </div>
                        <div class="ms-3 text-end flex-shrink-0">
                          <div class="fw-bolder text-dark fs-7">{{ p.total }} {{ $t('dashboard_kpi.unit_short') }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ─── Top Clients ───────────────────────────────────────────── -->
        <div class="row mb-5">
          <div class="col-12">
            <div class="card dashboard-card">
              <div class="card-header border-0 pt-6 pb-4">
                <div class="card-title d-flex align-items-center gap-3">
                  <div class="section-icon bg-light-success">
                    <i class="bi bi-people text-success fs-2"></i>
                  </div>
                  <div>
                    <h3 class="fw-bolder mb-0">{{ $t('dashboard_kpi.top_clients') }}</h3>
                    <span class="text-muted fs-7">{{ $t('dashboard_kpi.top_clients_subtitle') }}</span>
                  </div>
                </div>
              </div>
              <div class="card-body pt-2">
                <div class="text-center py-10" v-if="bestSalesCustomersEmpty && mostOrdersCustomersEmpty">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="h-150px" />
                  <div class="text-gray-400 fs-5 fw-bold mt-3">{{ $t('no_data_found') }}</div>
                </div>
                <!-- Mobile : leaderboard -->
                <div v-else-if="isMobile">
                  <!-- Par CA -->
                  <div class="text-muted fs-8 fw-bold text-uppercase ls-1 mb-3">
                    <i class="bi bi-currency-dollar me-1"></i>{{ $t('dashboard_kpi.by_turnover') }}
                  </div>
                  <div class="client-leaderboard mb-5">
                    <div
                      v-for="(c, i) in bestSalesCustomers.slice(0, 8)"
                      :key="'cl'+i"
                      class="leaderboard-row"
                      :class="i === 0 ? 'leaderboard-row--gold' : i === 1 ? 'leaderboard-row--silver' : i === 2 ? 'leaderboard-row--bronze' : ''"
                    >
                      <div class="leaderboard-rank">
                        <span v-if="i === 0">🥇</span>
                        <span v-else-if="i === 1">🥈</span>
                        <span v-else-if="i === 2">🥉</span>
                        <span v-else class="leaderboard-rank-num">{{ i + 1 }}</span>
                      </div>
                      <div class="leaderboard-avatar" :style="{ background: clientAvatarColor(i) }">
                        {{ clientInitials(c.client) }}
                      </div>
                      <div class="leaderboard-info">
                        <div class="leaderboard-name">{{ c.client }}</div>
                        <div class="leaderboard-bar">
                          <div class="leaderboard-bar-fill"
                            :style="{ width: Math.round(c.montant / (bestSalesCustomers[0]?.montant || 1) * 100) + '%' }">
                          </div>
                        </div>
                      </div>
                      <div class="leaderboard-amount">
                        {{ $formatLocalAmount(c.montant) }}
                        <small>{{ currency }}</small>
                      </div>
                    </div>
                  </div>

                  <!-- Par nb commandes -->
                  <div class="text-muted fs-8 fw-bold text-uppercase ls-1 mb-3">
                    <i class="bi bi-cart-check me-1"></i>{{ $t('dashboard_kpi.by_order_count') }}
                  </div>
                  <div class="client-leaderboard">
                    <div
                      v-for="(c, i) in mostOrdersCustomers.slice(0, 8)"
                      :key="'co'+i"
                      class="leaderboard-row"
                      :class="i === 0 ? 'leaderboard-row--gold' : i === 1 ? 'leaderboard-row--silver' : i === 2 ? 'leaderboard-row--bronze' : ''"
                    >
                      <div class="leaderboard-rank">
                        <span v-if="i === 0">🥇</span>
                        <span v-else-if="i === 1">🥈</span>
                        <span v-else-if="i === 2">🥉</span>
                        <span v-else class="leaderboard-rank-num">{{ i + 1 }}</span>
                      </div>
                      <div class="leaderboard-avatar" :style="{ background: clientAvatarColor(i) }">
                        {{ clientInitials(c.client) }}
                      </div>
                      <div class="leaderboard-info">
                        <div class="leaderboard-name">{{ c.client }}</div>
                        <div class="leaderboard-bar">
                          <div class="leaderboard-bar-fill leaderboard-bar-fill--orders"
                            :style="{ width: Math.round(c.most / (mostOrdersCustomers[0]?.most || 1) * 100) + '%' }">
                          </div>
                        </div>
                      </div>
                      <div class="leaderboard-amount">
                        {{ c.most }}
                        <small>{{ $t('dashboard_kpi.order_count_short') }}</small>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Desktop : chart + classement -->
                <div v-else class="row g-5 align-items-start">
                  <!-- Chart CA -->
                  <div class="col-lg-8">
                    <div class="text-muted fs-8 fw-bold text-uppercase ls-1 mb-3">
                      <i class="bi bi-currency-dollar me-1"></i>{{ $t('dashboard_kpi.by_turnover') }}
                    </div>
                    <div id="chart_top_clients_amount" style="height:320px"></div>
                  </div>
                  <!-- Classement par nb commandes -->
                  <div class="col-lg-4">
                    <div class="text-muted fs-8 fw-bold text-uppercase ls-1 mb-3">
                      <i class="bi bi-cart-check me-1"></i>{{ $t('dashboard_kpi.by_order_count') }}
                    </div>
                    <div class="top-rank-list">
                      <div v-for="(c, i) in mostOrdersCustomers.slice(0, 8)" :key="'co'+i" class="rank-item">
                        <div class="client-avatar" :style="{ background: clientAvatarColor(i) }">
                          {{ clientInitials(c.client) }}
                        </div>
                        <div class="flex-grow-1 min-w-0">
                          <div class="fw-bold text-dark fs-7 text-truncate mb-1">{{ c.client }}</div>
                          <div class="progress" style="height:5px;border-radius:3px">
                            <div class="progress-bar bg-info"
                              :style="{ width: Math.round(c.most / (mostOrdersCustomers[0]?.most || 1) * 100) + '%' }">
                            </div>
                          </div>
                        </div>
                        <div class="ms-3 text-end flex-shrink-0">
                          <div class="fw-bolder text-dark fs-7">{{ c.most }} {{ $t('dashboard_kpi.order_count_short') }}</div>
                          <div class="text-muted fs-9">{{ i === 0 ? '🏆' : '' }}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->

        <!--end::Row-->

        <!-- Top Catégories -->
        <div class="row gy-5 g-xl-10 mb-5">
          <div class="col-12">
            <div class="card card-flush dashboard-card">
              <div class="card-header border-0 pt-6">
                <div class="card-title d-flex align-items-center">
                  <div class="card-icon bg-light-warning me-3">
                    <i class="bi bi-tags text-warning fs-2"></i>
                  </div>
                  <div>
                    <h3 class="fw-bold mb-0">{{ $t('dashboard.topCategory') }}</h3>
                    <span class="text-muted fs-7">{{ $t('dashboard.categories_performance') || 'Répartition par catégorie' }}</span>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="text-center py-10" v-if="categoriesEmpty">
                  <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px mb-4" />
                  <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
                </div>
                <template v-else>
                  <!-- Mobile : liste avec rang et barre -->
                  <div v-if="isMobile" class="cat-rank-list">
                    <div v-for="(c, i) in categories" :key="c.name" class="cat-rank-row">
                      <div class="cat-rank-num" :style="{ color: catColor(i) }">{{ i + 1 }}</div>
                      <div class="cat-rank-info">
                        <div class="cat-rank-name">{{ c.name }}</div>
                        <div class="cat-rank-bar">
                          <div class="cat-rank-bar-fill" :style="{
                            width: totalCategoriesQty > 0 ? ((c.total / totalCategoriesQty) * 100).toFixed(1) + '%' : '0%',
                            background: catColor(i)
                          }"></div>
                        </div>
                      </div>
                      <div class="cat-rank-right">
                        <div class="cat-rank-qty" :style="{ color: catColor(i) }">{{ c.total }} <small>{{ $t('dashboard_kpi.units') }}</small></div>
                        <div class="cat-rank-pct">{{ totalCategoriesQty > 0 ? ((c.total / totalCategoriesQty) * 100).toFixed(1) + '%' : '—' }}</div>
                      </div>
                    </div>
                  </div>
                  <!-- Desktop : pie chart -->
                  <div v-else id="dashboard_amchart_most_categories" style="height: 350px"></div>
                </template>
              </div>
            </div>
          </div>
        </div>

        <!--end::Row-->
      </div>
      <div class="container-xxl" v-show="!isReady">
        <Loader />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import 'intro.js/introjs.css';
import Loader from "@/components/Loader.vue";
export default {
  components: { Loader },
  data() {
    return {
      title: "navigation.dashboard",
      breadcrumbs: [
        {
          name: 'navigation.dashboard',
          path: '/admin'
        },
      ],
      startDate: null,
      endDate: null,
      shops: [],
      shop_selected: 'all',
      contacts: 0,
      products: 0,
      turnover: 0,
      currency: '',
      sales: [],
      iso: '',
      categories: [],
      productMostSalesNumber: [],
      productMostSalesAmount: [],
      isMobile: window.innerWidth <= 767,
      mostOrdersCustomers: [],
      bestSalesCustomers: [],
      weeklySales: [],
      // Les heures de pointe par canal (null : le filtre exclut ce canal) : [{ weekday 1 lundi … 7 dimanche, hour,
      // sales_count }], seulement les cases avec des ventes, en heure locale.
      peakHours: { pos: null, online: null },
      // Le canal affiché : la caisse par défaut, l'en ligne quand le filtre est « E-commerce ».
      heatChannel: 'pos',
      // Sous ce nombre de commandes en ligne, la grille montre des points isolés plutôt qu'une tendance.
      MIN_ONLINE_ORDERS: 30,
      salesView: 'daily',

      stockAlerts: null,
      weeklyApexChart: null,
      topProductAmountChart: null,
      topClientAmountChart: null,
      isReady: false,
      stats: {
        ecommerce: {},
        pos: {},
        combined: {},
        top_products: [],
        top_categories: [],
        promotions: [],
        code_promos: []
      },
    }
  },

  watch: {
    shop_selected: async function (value) {
      this.isReady = false
      if (value) {
        await this.reloadInformation()
      }

    },
    '$i18n.locale' : function(value){
      if(value){
        this.$nextTick(() =>   this.initDateRange())
        }
    },

  },

  computed: {
    // Les canaux disponibles : la caisse sauf en « E-commerce » ; l'en ligne si le module est actif (ou le filtre).
    heatChannels() {
      const channels = []
      if (this.peakHours.pos !== null) channels.push('pos')
      if (this.peakHours.online !== null && (this.shop_selected === 'ecommerce' || this.$hasModule('ecommerce'))) channels.push('online')
      return channels
    },
    salesByWeekdayHour() {
      return this.peakHours[this.heatChannel] || []
    },
    heatTotal() {
      return this.salesByWeekdayHour.reduce((sum, cell) => sum + Number(cell.sales_count), 0)
    },
    heatTooFew() {
      return this.heatChannel === 'online' && this.heatTotal < this.MIN_ONLINE_ORDERS
    },
    heatCells() {
      return new Map((this.salesByWeekdayHour || []).map(cell => [`${cell.weekday}-${cell.hour}`, Number(cell.sales_count)]))
    },
    // Les heures montrées : de la première à la dernière vente, 8 h – 20 h au moins.
    heatHours() {
      const seen = (this.salesByWeekdayHour || []).map(cell => Number(cell.hour))
      const first = Math.min(8, ...seen)
      const last = Math.max(20, ...seen)
      return Array.from({ length: last - first + 1 }, (_, index) => first + index)
    },
    heatMax() {
      return Math.max(0, ...this.heatCells.values())
    },
    // Le créneau le plus chargé, écrit en clair sous le titre.
    heatPeak() {
      const cells = this.salesByWeekdayHour || []
      if (!cells.length) return null
      const best = cells.reduce((top, cell) => (Number(cell.sales_count) > Number(top.sales_count) ? cell : top))
      const n = Number(best.sales_count)
      return this.$t('statistics.peak', { day: this.$t(`statistics.weekdays_long.${best.weekday}`), from: best.hour, to: Number(best.hour) + 1, n }, n)
    },
    // Sous le titre : en ligne, à quoi sert la grille ; en caisse, le créneau le plus chargé.
    heatSubtitle() {
      if (this.heatChannel === 'online') return this.$t('dashboard_kpi.heat_online_help')
      return this.heatPeak || this.$t('dashboard_kpi.heat_pos_help')
    },
    totalCategoriesQty() {
      return (this.categories || []).reduce((sum, c) => sum + parseFloat(c.total || 0), 0)
    },
    salesEmpty() {
      return (this.sales?.reduce(
        (accumulator, currentValue) => accumulator + currentValue.value, 0
      )) == 0
    },
    weeklyEmpty() {
      return (this.weeklySales?.reduce(
          (accumulator, currentValue) => accumulator + (currentValue.total_sales || 0), 0
      )) == 0
    },
    productMostSalesAmountEmpty() {
      return (this.productMostSalesAmount?.reduce(
        (accumulator, currentValue) => accumulator + currentValue.total, 0
      )) == 0
    },

    productMostSalesNumberEmpty() {
      return (this.productMostSalesAmount?.reduce(
        (accumulator, currentValue) => accumulator + currentValue.total, 0
      )) == 0
    },
    bestSalesCustomersEmpty() {
      return (this.bestSalesCustomers?.reduce(
        (accumulator, currentValue) => accumulator + currentValue.amount, 0
      )) == 0
    },
    mostOrdersCustomersEmpty() {
      return (this.bestSalesCustomers?.reduce(
        (accumulator, currentValue) => accumulator + currentValue.most, 0
      )) == 0
    },
    categoriesEmpty() {
      return (this.categories?.reduce(
        (accumulator, currentValue) => accumulator + currentValue.total, 0
      )) == 0
    },
    avgBasketEcommerce() {
      const ca = this.stats?.ecommerce?.total_paid_orders || 0
      const orders = this.stats?.ecommerce?.paid_orders || 0
      return orders > 0 ? this.$formatLocalAmount(Math.round(ca / orders)) : '—'
    },
    avgBasketPos() {
      const ca = this.stats?.pos?.total_paid_orders || 0
      const sales = this.stats?.pos?.total_sales_count || 0
      return sales > 0 ? this.$formatLocalAmount(Math.round(ca / sales)) : '—'
    },
    avgBasketCombined() {
      const ca = this.stats?.combined?.total_paid_orders || 0
      const orders = this.paidOrdersCount
      return orders > 0 ? this.$formatLocalAmount(Math.round(ca / orders)) : '—'
    },
    periodCaTotal() {
      return this.$formatLocalAmount(this.stats?.combined?.total_paid_orders || 0)
    },
    // ventes comprises dans le CA de la période (commandes payées + ventes en caisse), pas toutes
    // les commandes passées — sinon le nombre ne correspond pas au montant affiché à côté
    paidOrdersCount() {
      const combined = this.stats?.combined || {}
      return combined.paid_orders_all ?? combined.paid_orders ?? combined.total_sales_count ?? 0
    },
    periodOrdersTotal() {
      return this.paidOrdersCount
    },
    periodAvgDay() {
      const total = this.stats?.combined?.total_paid_orders || 0
      const days  = this.sales?.length || 1
      return this.$formatLocalAmount(Math.round(total / days))
    },
    locale() {
      return this.$i18n?.locale;
    },
  },

  beforeUnmount() {
    window.removeEventListener('resize', this._onResize)
  },

  async mounted() {
    window.addEventListener('resize', this._onResize = () => {
      this.isMobile = window.innerWidth <= 767
    })
    this.isReady = false
    this.shop_selected = 'all'
    KTApp.initSelect2()
    await this.initSelect()
    await this.loadUserShops()
    await this.initDateRange()
    if (this.shops && this.shops.length) {
      this.shop_selected = 'all'
    }

  },

  methods: {
    ...mapActions('shop', ['getCurrency']),
    isUUID(value) {
      // regex simple pour tester si la valeur ressemble à un UUID
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value);
    },
    async loadUserShops() {
      this.isReady = false
      await axios.get(`/dashboard/shops`)
        .then((response) => {
          this.shops = response.data.shops
        })
        .catch((error) => {
          console.log(error)
        })
    },
    async initDateRange() {
      this.isReady = false
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]');
      let start = moment().subtract(29, 'days');
      let end = moment();

      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')

      $(element).daterangepicker({
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        locale: {
          format: 'DD/MM/YYYY',
          separator: ' - ',
          applyLabel: i18n.global.t('apply'),
          cancelLabel: i18n.global.t('cancel'),
          fromLabel: i18n.global.t('from'),
          toLabel: i18n.global.t('to'),
          customRangeLabel: i18n.global.t('custom_range'),
          weekLabel: 'S',
          daysOfWeek: [i18n.global.t('di'),i18n.global.t('lu'),i18n.global.t('ma'),i18n.global.t('me'),i18n.global.t('je'),i18n.global.t('ve'),i18n.global.t('sa')],
          monthNames: [i18n.global.t('january'), i18n.global.t('february'), i18n.global.t('march'), i18n.global.t('april'), i18n.global.t('may'),
            i18n.global.t('june'), i18n.global.t('july'),  i18n.global.t('august'),  i18n.global.t('september'),  i18n.global.t('october'),  i18n.global.t('november'),  i18n.global.t('december')],
          firstDay: 1
        },
        ranges: {
          [i18n.global.t('today')]: [moment(), moment()],
          [i18n.global.t('yesterday')]: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
          [i18n.global.t('last7Days')]: [moment().subtract(6, 'days'), moment()],
          [i18n.global.t('last30Days')]: [moment().subtract(29, 'days'), moment()],
          [i18n.global.t('thisMonth')]: [moment().startOf('month'), moment().endOf('month')],
          [i18n.global.t('lastMonth')]: [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]

        }
      }, this.cb);

      this.cb(start, end);

    },


    async cb(start, end) {
      this.isReady = false
      let element = document.querySelector('[dashboard-kt-daterangepicker="true"]');
      let display = element.querySelector('div');
      if (display) {
        display.innerHTML = start.format('D MMM YYYY') + ' - ' + end.format('D MMM YYYY');
      }
      this.startDate = start.format('DD-MM-YYYY')
      this.endDate = end.format('DD-MM-YYYY')
      if (this.startDate && this.endDate) {
        await this.reloadInformation()
      }

    },

    async fetchKPIStats() {
      if (this.shop_selected && this.startDate && this.endDate) {
        try {
          const response = await axios.get(`/get/kpi/statistics?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
          this.stats = response.data
        } catch (error) {
          console.error('Erreur fetchKPIStats:', error)
        }
      }
    },

    async fetchStockAlerts() {
      try {
        const res = await axios.get(`/dashboard/statistics/stock-alerts?shop=${this.shop_selected}`)
        this.stockAlerts = res.data
      } catch (e) {
        this.stockAlerts = null
      }
    },

    async fetchWeeklyStats() {
      if (this.shop_selected && this.startDate && this.endDate) {
        try {
          const response = await axios.get(`/get/weekly/statistics?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
          this.weeklySales = response.data.weekly_sales || []
        } catch (error) {
          console.error('Erreur fetchWeeklyStats:', error)
        }
      }
    },





    async reloadInformation() {
      this.isReady = false
      try {
        let response = await this.getCurrency()
        this.iso = response?.data.currency_symbol
        this.currency = response.data.currency_symbol ? response.data.currency_symbol : response.data.symbol_native

        // Charger toutes les données en parallèle
        await Promise.all([
          this.loadStatisticsData(),
          this.loadStaticsCount(),
          this.fetchKPIStats(),
          this.fetchWeeklyStats(),
          this.fetchStockAlerts()
        ])

        // Initialiser les graphiques après que toutes les données soient chargées
        this.$nextTick(() => {
          this.initSaleChart()
          this.initWeeklyChartApex()
          this.initCategoriesChart()
          this.initTopProductsAmountOnly()
          this.initTopClientsAmountOnly()
        })
      } catch (error) {
        console.error('Erreur lors du chargement des données:', error)
      } finally {
        this.isReady = true
      }
    },

    async initSelect() {
      let kt_select = $('body .kt_select')
      kt_select.select2()
      kt_select.change((e) => {
        switch (e.target.name) {
          case 'filter':
            this.shop_selected = e.target.value
            break;
        }
      });
    },

    async loadStaticsCount() {
      if (this.shop_selected && this.startDate && this.endDate) {
        try {
          const response = await axios.get(`/dashboard/statistics/count?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
          this.contacts = response.data.contacts
          this.products = response.data.products
          this.turnover = this.$formatLocalAmount(response.data.turnover)
        } catch (error) {
          console.error('Erreur loadStaticsCount:', error)
        }
      }
    },

    async loadStatisticsData() {
      if (this.shop_selected && this.startDate && this.endDate) {
        await axios.get(`/dashboard/statistics/data?shop=${this.shop_selected}&startDate=${this.startDate}&endDate=${this.endDate}`)
          .then((response) => {
            this.sales = response.data.sales
            this.categories = response.data.categories
            this.productMostSalesNumber = response.data.productMostSalesNumber
            this.productMostSalesAmount = response.data.productMostSalesAmount
            this.mostProductsCustomers = response.data.mostProductsCustomers
            this.bestSalesCustomers = response.data.bestSalesCustomers
            this.mostOrdersCustomers = response.data.mostOrdersCustomers
            this.peakHours = response.data.peak_hours || { pos: null, online: null }
            if (!this.heatChannels.includes(this.heatChannel)) this.heatChannel = this.heatChannels[0] || 'pos'
          })
          .catch((error) => {
          })
      }
    },


    initSaleChart() {
      const element = document.getElementById("kt_charts_widget_3");
      if (!element) return;

      const height = parseInt(getComputedStyle(element).height);
      const labelColor  = getComputedStyle(document.documentElement).getPropertyValue('--kt-gray-500');
      const borderColor = getComputedStyle(document.documentElement).getPropertyValue('--kt-border-dashed-color');
      const primaryColor = '#3699FF';

      const salesData  = this.sales.map(s => s.value);
      const categories = this.sales.map(s => s.date);

      const options = {
        series: [{ name: this.$t('dashboard_kpi.sales'), data: salesData }],
        colors: [primaryColor],
        chart: {
          fontFamily: 'inherit',
          type: 'area',
          height: height,
          toolbar: { show: false },
          zoom: { enabled: true },
        },
        fill: {
          type: 'gradient',
          gradient: {
            shade: 'light',
            type: 'vertical',
            shadeIntensity: 0.3,
            opacityFrom: 0.25,
            opacityTo: 0,
            stops: [0, 85, 100],
          },
        },
        stroke: {
          curve: 'smooth',
          width: 3,
          colors: [primaryColor],
        },
        dataLabels: { enabled: false },
        xaxis: {
          categories,
          axisBorder: { show: false },
          axisTicks: { show: false },
          tickAmount: Math.floor(categories.length / 4),
          labels: { rotate: 0, style: { colors: labelColor, fontSize: '12px' } },
          crosshairs: { position: 'front', stroke: { color: primaryColor, width: 1, dashArray: 3 } },
        },
        yaxis: {
          tickAmount: 4,
          labels: {
            style: { colors: labelColor, fontSize: '12px' },
            formatter: val => this.$formatLocalAmount(val) + ' ' + this.iso,
          },
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: { formatter: val => this.$formatLocalAmount(val) + ' ' + this.iso },
          style: { fontSize: '12px' },
        },
        grid: { borderColor, strokeDashArray: 4, yaxis: { lines: { show: true } } },
        markers: { colors: [primaryColor], strokeColors: '#fff', strokeWidth: 3, size: 5, hover: { size: 7 } },
        responsive: [
          {
            breakpoint: 768,
            options: {
              chart: { height: 220 },
              xaxis: {
                tickAmount: Math.min(4, Math.floor(categories.length / 3)),
                labels: { rotate: -45, rotateAlways: true, style: { fontSize: '10px' } },
              },
              yaxis: {
                tickAmount: 3,
                labels: {
                  style: { fontSize: '10px' },
                  formatter: val => this.$formatLocalAmount(val),
                },
              },
              markers: { size: 3 },
              stroke: { width: 2 },
            },
          },
          {
            breakpoint: 480,
            options: {
              chart: { height: 180 },
              xaxis: {
                tickAmount: 3,
                labels: { rotate: -45, rotateAlways: true, style: { fontSize: '9px' } },
              },
              yaxis: { show: false },
              markers: { size: 0 },
              stroke: { width: 2 },
            },
          },
        ],
      };

      if (this.chartApex) {
        this.chartApex.destroy();
      }

      this.chartApex = new ApexCharts(element, options);
      this.chartApex.render();
    },

    initCategoriesChart() {
      am4core.ready(() => {
        am4core.useTheme(am4themes_animated);

        var chartCategories = am4core.create("dashboard_amchart_most_categories", am4charts.PieChart);
        chartCategories.hiddenState.properties.opacity = 0;

        chartCategories.data = this.categories;
        chartCategories.validateData();

        var seriesCategories = chartCategories.series.push(new am4charts.PieSeries());
        seriesCategories.dataFields.value = "total";
        seriesCategories.dataFields.radiusValue = "total";
        seriesCategories.dataFields.category = "name";
        seriesCategories.slices.template.cornerRadius = 6;
        seriesCategories.slices.template.stroke = am4core.color('#fff');
        seriesCategories.slices.template.strokeWidth = 2;

        seriesCategories.hiddenState.properties.endAngle = -90;

        // Palette bien contrastée appliquée via adapter (seule méthode fiable sur PieSeries)
        var pieColors = [
          '#3699FF','#50CD89','#FFC700','#F1416C',
          '#7239EA','#00B2FF','#FF6D00','#26C6DA',
          '#E91E63','#009688','#FF5722','#9C27B0',
        ];
        seriesCategories.slices.template.adapter.add('fill', (fill, target) => {
          if (target.dataItem) {
            return am4core.color(pieColors[target.dataItem.index % pieColors.length]);
          }
          return fill;
        });
        seriesCategories.slices.template.adapter.add('stroke', (stroke, target) => {
          if (target.dataItem) {
            return am4core.color(pieColors[target.dataItem.index % pieColors.length]);
          }
          return stroke;
        });

        chartCategories.legend = new am4charts.Legend();
        chartCategories.legend.position = "bottom";
      });
    },


    initProductMostSaleNumber() {
      am4core.ready(() => {
        am4core.useTheme(am4themes_animated);

        var chart = am4core.create("dashboard_amchart_most_products_sale_number", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        var colorSet = new am4core.ColorSet();
        colorSet.list = ['#3699FF','#50CD89','#FFC700','#F1416C','#7239EA','#00B2FF','#FF6D00','#26C6DA'].map(c => am4core.color(c));
        chart.colors = colorSet;

        chart.data = this.productMostSalesNumber;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "title";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;

        var series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "total";
        series.dataFields.categoryX = "title";
        series.tooltipText = "[bold]{categoryX}[/]\n{valueY} unité(s)";
        series.columns.template.strokeWidth = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.columns.template.column.cornerRadiusTopLeft = 8;
        series.columns.template.column.cornerRadiusTopRight = 8;
        series.columns.template.column.fillOpacity = 0.85;

        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", (fill, target) =>
          chart.colors.getIndex(target.dataItem.index)
        );

        chart.cursor = new am4charts.XYCursor();
      });
    },

    initProductMostSaleAmount() {
      am4core.ready(() => {
        am4core.useTheme(am4themes_animated);

        var chart = am4core.create("dashboard_amchart_most_products_sale_amount", am4charts.XYChart);
        chart.scrollbarX = new am4core.Scrollbar();

        var colorSet = new am4core.ColorSet();
        colorSet.list = ['#3699FF','#50CD89','#FFC700','#F1416C','#7239EA','#00B2FF','#FF6D00','#26C6DA'].map(c => am4core.color(c));
        chart.colors = colorSet;

        chart.data = this.productMostSalesAmount;

        var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
        categoryAxis.dataFields.category = "title";
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        categoryAxis.renderer.labels.template.rotation = 270;
        categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 110;

        var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 50;

        var series = chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.valueY = "total";
        series.dataFields.categoryX = "title";
        series.tooltipText = "[bold]{categoryX}[/]\n{valueY} " + this.currency;
        series.columns.template.strokeWidth = 0;
        series.tooltip.pointerOrientation = "vertical";
        series.columns.template.column.cornerRadiusTopLeft = 8;
        series.columns.template.column.cornerRadiusTopRight = 8;
        series.columns.template.column.fillOpacity = 0.85;

        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", (fill, target) =>
          chart.colors.getIndex(target.dataItem.index)
        );

        chart.cursor = new am4charts.XYCursor();
      });
    },

    initTopClientsAmountOnly() {
      if (this.topClientAmountChart) { this.topClientAmountChart.destroy(); this.topClientAmountChart = null }
      if (this.bestSalesCustomersEmpty) return
      const cur = this.currency ? ' ' + this.currency : ''
      const data = this.bestSalesCustomers.slice(0, 8)
      const palette = ['#50CD89','#3699FF','#FFC700','#F1416C','#7239EA','#00B2FF','#FF6D00','#26C6DA']
      this.topClientAmountChart = this._apexHBar(
        'chart_top_clients_amount',
        data.map(c => c.montant),
        data.map(c => c.client),
        palette,
        v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + cur,
        v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + cur,
      )
    },

    heatCount(day, hour) {
      return this.heatCells.get(`${day}-${hour}`) || 0
    },
    // Cinq niveaux de la même teinte ; 0 : case vide.
    heatLevel(count) {
      return count <= 0 || this.heatMax === 0 ? 0 : Math.min(5, Math.ceil((count / this.heatMax) * 5))
    },

    setSalesView(view) {
      this.salesView = view
      this.$nextTick(() => {
        if (view === 'daily') this.initSaleChart()
        else this.initWeeklyChartApex()
      })
    },

    catColor(i) {
      const palette = ['#3699FF','#50CD89','#FFC700','#F1416C','#7239EA','#00B2FF','#FF6D00','#26C6DA','#E91E63','#009688']
      return palette[i % palette.length]
    },

    clientInitials(name) {
      if (!name) return '?'
      return name.trim().split(/\s+/).map(w => w[0]).join('').toUpperCase().slice(0, 2)
    },
    clientAvatarColor(i) {
      const colors = ['#3699ff22','#50cd8922','#ffc70022','#f1416c22','#7239ea22','#00b2ff22']
      return colors[i % colors.length]
    },

    initWeeklyChartApex() {
      if (this.weeklyApexChart) { this.weeklyApexChart.destroy(); this.weeklyApexChart = null }
      const el = document.getElementById('chart_weekly_apex')
      if (!el || this.weeklyEmpty) return

      const gray   = KTUtil.getCssVariableValue('--bs-gray-500')
      const dashed = KTUtil.getCssVariableValue('--bs-border-dashed-color')
      const cur    = this.currency ? ' ' + this.currency : ''

      this.weeklyApexChart = new ApexCharts(el, {
        series: [
          { name: this.$t('dashboard_kpi.ca_short'), type: 'bar',  data: this.weeklySales.map(w => parseFloat((w.total_sales  || 0).toFixed(2))) },
          { name: this.$t('dashboard_kpi.orders'),   type: 'line', data: this.weeklySales.map(w => w.total_orders || 0) },
        ],
        chart: { type: 'bar', height: 320, toolbar: { show: false }, fontFamily: 'inherit' },
        plotOptions: { bar: { columnWidth: '52%', borderRadius: 6 } },
        stroke: { width: [0, 3], curve: 'smooth' },
        colors: ['#3699FF', '#50cd89'],
        fill: {
          type: ['gradient', 'solid'],
          gradient: { shade: 'light', type: 'vertical', opacityFrom: 0.9, opacityTo: 0.65 },
        },
        markers: { size: [0, 5], colors: ['#fff'], strokeColors: '#50cd89', strokeWidth: 2 },
        xaxis: {
          categories: this.weeklySales.map(w => w.week_start),
          labels: { style: { colors: gray, fontSize: '11px' } },
          axisBorder: { show: false }, axisTicks: { show: false },
        },
        yaxis: [
          {
            title: { text: cur ? this.$t('dashboard_kpi.ca_short') + ' (' + cur.trim() + ')' : this.$t('dashboard_kpi.ca_short'), style: { color: gray, fontSize: '11px' } },
            labels: { style: { colors: gray }, formatter: v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) },
          },
          {
            opposite: true,
            title: { text: this.$t('dashboard_kpi.orders'), style: { color: '#50cd89', fontSize: '11px' } },
            labels: { style: { colors: '#50cd89' }, formatter: v => Math.round(v) },
          },
        ],
        dataLabels: {
          enabled: true, enabledOnSeries: [1],
          formatter: v => v, style: { fontSize: '11px', colors: ['#50cd89'] },
        },
        tooltip: {
          shared: true, intersect: false,
          y: [
            { formatter: v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + cur },
            { formatter: v => v + this.$t('dashboard_kpi.orders_suffix') },
          ],
        },
        grid: { borderColor: dashed, strokeDashArray: 4, yaxis: { lines: { show: true } } },
        legend: { show: true, position: 'top', markers: { radius: 4 } },
        responsive: [
          {
            breakpoint: 768,
            options: {
              chart: { height: 220 },
              plotOptions: { bar: { columnWidth: '70%', borderRadius: 4 } },
              xaxis: { labels: { rotate: -45, rotateAlways: true, style: { fontSize: '10px' } } },
              yaxis: [
                { labels: { style: { fontSize: '10px' }, formatter: v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) } },
                { opposite: true, labels: { style: { fontSize: '10px' }, formatter: v => Math.round(v) } },
              ],
              markers: { size: [0, 3] },
              dataLabels: { enabled: false },
            },
          },
          {
            breakpoint: 480,
            options: {
              chart: { height: 180 },
              plotOptions: { bar: { columnWidth: '80%', borderRadius: 3 } },
              xaxis: { labels: { rotate: -45, rotateAlways: true, style: { fontSize: '9px' } } },
              yaxis: [
                { show: false },
                { show: false },
              ],
              markers: { size: [0, 0] },
              dataLabels: { enabled: false },
              legend: { show: false },
            },
          },
        ],
      })
      this.weeklyApexChart.render()
    },

    _apexHBar(elId, seriesData, categories, color, labelFmt, tooltipFmt) {
      const gray   = KTUtil.getCssVariableValue('--bs-gray-500')
      const dashed = KTUtil.getCssVariableValue('--bs-border-dashed-color')
      const el = document.getElementById(elId)
      if (!el) return null
      const chart = new ApexCharts(el, {
        series: [{ name: '', data: seriesData }],
        chart: { type: 'bar', height: 340, toolbar: { show: false }, fontFamily: 'inherit' },
        plotOptions: { bar: { horizontal: true, barHeight: '62%', borderRadius: 6, distributed: true } },
        colors: color,
        dataLabels: { enabled: true, formatter: labelFmt, style: { fontSize: '11px', fontWeight: 600 } },
        xaxis: {
          categories,
          labels: { style: { colors: gray, fontSize: '11px' }, formatter: v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) },
        },
        yaxis: { labels: { style: { colors: gray, fontSize: '11px' }, maxWidth: 180 } },
        legend: { show: false },
        tooltip: { y: { formatter: tooltipFmt } },
        grid: { borderColor: dashed, strokeDashArray: 4 },
      })
      chart.render()
      return chart
    },

    initTopProductsAmountOnly() {
      if (this.topProductAmountChart) { this.topProductAmountChart.destroy(); this.topProductAmountChart = null }
      if (this.productMostSalesAmountEmpty) return
      const cur = this.currency ? ' ' + this.currency : ''
      const data = this.productMostSalesAmount.slice(0, 8)
      const palette = ['#3699FF','#50CD89','#FFC700','#F1416C','#7239EA','#00B2FF','#FF6D00','#26C6DA']
      this.topProductAmountChart = this._apexHBar(
        'chart_top_products_amount',
        data.map(p => p.total),
        data.map(p => p.title),
        palette,
        v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + cur,
        v => Number(v).toLocaleString('fr-FR', { maximumFractionDigits: 0 }) + cur,
      )
    },

  }
}
</script>

<style scoped>
/* Les heures de pointe : grille jour × heure, une teinte en cinq niveaux, case vide en gris très clair. */
.heatmap-scroll {
  overflow-x: auto;
}

.heatmap {
  display: grid;
  grid-template-columns: 36px repeat(var(--hours), minmax(18px, 1fr));
  gap: 3px;
  min-width: 480px;
}

.heatmap-hour {
  color: var(--bs-gray-500);
  font-size: 10px;
  text-align: center;
}

.heatmap-day {
  align-self: center;
  color: var(--bs-gray-600);
  font-size: 11px;
  font-weight: 600;
}

.heatmap-cell {
  height: 26px;
  border-radius: 4px;
  background: var(--bs-gray-100);
}

.heatmap-cell.level-1 { background: color-mix(in srgb, var(--bs-primary) 18%, #fff); }
.heatmap-cell.level-2 { background: color-mix(in srgb, var(--bs-primary) 38%, #fff); }
.heatmap-cell.level-3 { background: color-mix(in srgb, var(--bs-primary) 58%, #fff); }
.heatmap-cell.level-4 { background: color-mix(in srgb, var(--bs-primary) 80%, #fff); }
.heatmap-cell.level-5 { background: var(--bs-primary); }

.heatmap-legend {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: 12px;
  color: var(--bs-gray-500);
  font-size: 11px;
}

.heatmap-legend .heatmap-cell {
  width: 16px;
  height: 12px;
}

/* ─── Stock alert pills ───────────────────────────────────── */
.stock-alert-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  color: #5e6278;
  background: #fff;
  border: 1px solid #e4e6ef;
  text-decoration: none;
}
.stock-alert-pill.pill-link:hover { border-color: #b5b5c3; color: #181c32; }
.pill-dot {
  width: 7px; height: 7px;
  border-radius: 50%;
  display: inline-block;
}
.pill-rupture .pill-dot  { background: #dc3545; }
.pill-critique .pill-dot { background: #ffc107; }
.pill-alerte .pill-dot   { background: #0dcaf0; }

/* ─── Loader ─────────────────────────────────────────────── */
/* ─── Leaderboard clients mobile ─── */
.client-leaderboard {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.leaderboard-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f9f9f9;
  border: 1px solid #e4e6ef;
  transition: background 0.15s;
}
.leaderboard-row--gold   { background: #fffbea; border-color: #ffc700; }
.leaderboard-row--silver { background: #f4f4f4; border-color: #c0c0c0; }
.leaderboard-row--bronze { background: #fff5f0; border-color: #cd7f32; }

.leaderboard-rank {
  font-size: 1.3rem;
  width: 28px;
  flex-shrink: 0;
  text-align: center;
}
.leaderboard-rank-num {
  font-size: 0.85rem;
  font-weight: 700;
  color: #a1a5b7;
}

.leaderboard-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 700;
  color: #3f4254;
  flex-shrink: 0;
  border: 1px solid rgba(0,0,0,0.06);
}

.leaderboard-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.leaderboard-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e2130;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.leaderboard-bar {
  height: 4px;
  background: #e4e6ef;
  border-radius: 2px;
  overflow: hidden;
}
.leaderboard-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #50CD89, #3699FF);
  border-radius: 2px;
  transition: width 0.4s ease;
}
.leaderboard-bar-fill--orders {
  background: linear-gradient(90deg, #FFC700, #F1416C);
}

.leaderboard-amount {
  font-size: 0.85rem;
  font-weight: 700;
  color: #1e2130;
  text-align: right;
  flex-shrink: 0;
  white-space: nowrap;
}
.leaderboard-amount small {
  font-size: 0.65rem;
  font-weight: 500;
  color: #a1a5b7;
  margin-left: 2px;
}

/* ── Liste rang + barre (catégories mobile dashboard) ── */
.cat-rank-list { display: flex; flex-direction: column; gap: 12px; }

.cat-rank-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.cat-rank-num {
  font-size: 1rem;
  font-weight: 800;
  width: 22px;
  flex-shrink: 0;
  text-align: center;
}

.cat-rank-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.cat-rank-name {
  font-size: 0.85rem;
  font-weight: 600;
  color: #1e2130;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cat-rank-bar {
  height: 6px;
  background: #e4e6ef;
  border-radius: 3px;
  overflow: hidden;
}

.cat-rank-bar-fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.4s ease;
}

.cat-rank-right {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
  gap: 2px;
}
.cat-rank-qty {
  font-size: 0.85rem;
  font-weight: 700;
  white-space: nowrap;
}
.cat-rank-qty small {
  font-size: 0.65rem;
  font-weight: 500;
  color: #a1a5b7;
  margin-left: 2px;
}
.cat-rank-pct {
  font-size: 0.75rem;
  font-weight: 600;
  color: #a1a5b7;
}

.cat-stat-card {
  background: #f9f9f9;
  border: 1px solid #e4e6ef;
  border-radius: 10px;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  height: 100%;
}
.cat-stat-name {
  font-size: 0.78rem;
  font-weight: 600;
  color: #5e6278;
  line-height: 1.3;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.cat-stat-value {
  font-size: 1.1rem;
  font-weight: 700;
  line-height: 1.2;
}
.cat-stat-currency {
  font-size: 0.7rem;
  font-weight: 500;
  opacity: 0.75;
  margin-left: 2px;
}

/* ─── KPI Cards ──────────────────────────────────────────── */
.kpi-card {
  border-radius: 16px !important;
  border: none !important;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07) !important;
  min-width: 270px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  position: relative;
  overflow: hidden;
}
.kpi-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 28px rgba(0,0,0,0.11) !important;
}
.kpi-card::after {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  border-radius: 16px 16px 0 0;
}
.kpi-ecommerce::after { background: linear-gradient(90deg, #1cc88a, #52d9a8); }
.kpi-pos::after       { background: linear-gradient(90deg, #3699FF, #5bb8ff); }
.kpi-combined::after  { background: linear-gradient(90deg, #f6c23e, #ffda7a); }

.kpi-icon-box {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Compteurs en haut des cartes par canal (à droite du titre) */
.kpi-counters {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px 14px;
}
.kpi-counter {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.15;
}
.kpi-counter-value {
  font-size: 1.15rem;
  font-weight: 800;
}
.kpi-counter-label {
  font-size: 0.7rem;
  color: #a1a5b7;
  white-space: nowrap;
}

.kpi-big-number {
  font-size: 2.2rem;
  font-weight: 800;
  color: #1e1e2d;
  line-height: 1;
  letter-spacing: -1px;
}

/* ─── Section icons ──────────────────────────────────────── */
.section-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* ─── Dashboard cards (charts/tabs) ─────────────────────── */
.dashboard-card {
  border-radius: 16px !important;
  box-shadow: 0 2px 16px rgba(0,0,0,0.07) !important;
  border: none !important;
}
.dashboard-card .nav-tabs .nav-link {
  border: none;
  background: #f5f8fa;
  border-radius: 8px;
  padding: 0.5rem 1.1rem;
  font-size: 0.88rem;
  font-weight: 500;
  color: #6c757d;
  transition: all 0.2s;
}
.dashboard-card .nav-tabs .nav-link:hover  { background: #e9ecef; color: #333; }
.dashboard-card .nav-tabs .nav-link.active { background: #3699FF; color: #fff; }
.dashboard-card .tab-content { min-height: 350px; }

/* ─── Top products ranking list ─────────────────────────── */
.top-rank-list { display: flex; flex-direction: column; gap: 14px; }
.rank-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f9fafb;
  transition: background 0.2s;
}
.rank-item:hover { background: #f0f4ff; }
.rank-badge {
  width: 32px; height: 32px;
  border-radius: 8px;
  display: flex; align-items: center; justify-content: center;
  font-size: 1rem; font-weight: 700; flex-shrink: 0;
}
.rank-gold   { background: rgba(255,199,0,0.15);  color: #c49b00; }
.rank-silver { background: rgba(148,163,184,0.15); color: #64748b; }
.rank-bronze { background: rgba(205,127,50,0.15);  color: #8b5e3c; }
.rank-other  { background: #eff2f5; color: #6c757d; font-size: 0.85rem; }

/* ─── Client avatar ─────────────────────────────────────── */
.client-avatar {
  width: 36px; height: 36px;
  border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
  font-size: 0.75rem; font-weight: 700; color: #1e1e2d;
  flex-shrink: 0;
}

/* ─── Sales strip ────────────────────────────────────────── */
.ls-1 { letter-spacing: 0.05em; }

/* ─── Utility overrides ──────────────────────────────────── */
.bg-light-primary { background-color: rgba(54,153,255,0.1) !important; }
.bg-light-success { background-color: rgba(28,200,138,0.1) !important; }
.bg-light-warning { background-color: rgba(246,194,62,0.1)  !important; }
.bg-light-info    { background-color: rgba(54,185,204,0.1)  !important; }
table th, table td { vertical-align: middle; }

@media (max-width: 767px) {
  .chart-evolution-card .card-body { padding-bottom: 0 !important; }
  #kt_charts_widget_3, #chart_weekly_apex { height: 220px !important; }
}
@media (max-width: 479px) {
  #kt_charts_widget_3, #chart_weekly_apex { height: 180px !important; }
}
</style>